module.exports = __webpack_public_path__ + "static/media/prototype-illustration.fe9ecccb.svg";